<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     布局模板
  | @Version:   2018-11-27  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-container
    direction="vertical"
    class="the-layout">
    
    <el-container class="layout-container">
      <the-layout-header v-show="$route.name != 'DatavMap' "/>
      <the-layout-frame />
      <the-layout-menu />
      <the-layout-main />
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'TheLayout',
  components: {
    TheLayoutHeader: () => import('@/views/layout/TheLayoutHeader.vue'),
    TheLayoutFrame: () => import('@/views/layout/TheLayoutFrame.vue'),
    TheLayoutMenu: () => import('@/views/layout/TheLayoutMenu.vue'),
    TheLayoutMain: () => import('@/views/layout/TheLayoutMain.vue')
  },
}
</script>

<style lang="scss">
$--menu-inverse-bg: #252a2f;
.the-layout {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  .layout-container {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: $--menu-inverse-bg;
  }
}
</style>
